import axios from "./axios"

export default {
  getList: async (params) => {
    try {
      return await axios.get("/favorites", {
        params,
      })
    } catch (error) {
      throw error
    }
  },
  addRemoveToList: async (params) => {
    const { type, uuid, favorite, freelancerData } = params
    try {
      return await axios.post("/favorites", {
        type,
        uuid,
        favorite,
        ...(freelancerData && { freelancer_data: freelancerData }),
      })
    } catch (error) {
      throw error
    }
  },
}
